const artistsWishlistEN = {
    "view": {
        "table": {
            "title": "Your artists wishlist",
            "column": {
                "artist_name": "Artist Name",
                "spotify_id": "Spotify ID",
                "followers": "Followers",
                "popularity": "Popularity (%)",
                "action": "Action"
            },
            "dropdown": {
                "action": "Action",
                "addAsArtist": "Add As Artist",
                "delete": "Delete"
            },
            "button": {
                "export_csv": "Export CSV"                    
            },
            "placeholder": {
                "search": "Search..."
            },
            "message": {
                "error": "Something went wrong! Please refresh page and try again!"
            },
        },
        "modal": {
            "removeArtist": {
                "header": "Remove Artist {{artistName} From Wishlist",
                "body": "Are you sure that you want to remove artist {{artistName}} from your wishlist?"
            }
        },
        "message": {
            "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "noAccess": "You don't have access to this module, please contact the support team for further information."
        }
    },
};

export default artistsWishlistEN;